import { useState } from 'react';
import { useAcceptance } from '../../hooks/useAcceptance';
import { useAcceptanceData } from '../../hooks/useAcceptanceData';
import { useFullScreenModal } from '../../hooks/useFullScreenModal';

export function NotificationTerms() {
  const [agree, setAgree] = useState(false);

  const { acceptance, isLoading, onAccept } = useAcceptanceData('user_notification');

  const disabled = isLoading;

  return (
    <div className="flex justify-start items-start gap-[12px] mt-3">
      {agree ? (
        <img
          className="w-[24px] cursor-pointer pointer-events-auto shrink-0"
          alt="Checkbox"
          src={'/icons/famicons_checkbox.svg'}
          onClick={() => {
            setAgree(!agree);
            localStorage.setItem('user_notification', 0);
          }}
        />
      ) : (
        <div
          className="w-[24px] h-[24px] cursor-pointer border border-white rounded-[4px] pointer-events-auto shrink-0"
          alt="Checkbox"
          onClick={() => {
            setAgree(!agree);
            localStorage.setItem('user_notification', 1);
          }}
        />
      )}
      <p className="font-raleway font-medium text-xs text-white">
        Я хочу получать уведомления о новых лайках, сообщениях и важных событиях
      </p>
    </div>
  );
}
